// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   changeCurrencyApi,
//   getCurrencyPackApi,
//   loginApi,
//   priceApi,
//   subscribeApi,
// } from "../http/http";
// import ModalInfo from "../components/ModalInfo";
// import Loader from "../components/Loader";
// import { setCookie, setCookieUserId } from "../utils/helper";

// const SubscriptionPage = () => {
//   const [msisdn, setMsisdn] = useState("");
//   const [modal, setModal] = useState(false);
//   const [modalInfo, setModalInfo] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [subscribeLoading, setSubscribeLoading] = useState(false);
//   const [modalType, setModalType] = useState("");
//   const currencyOptions = [
//     { value: "USD", label: "USD" },
//     { value: "ZWG", label: "ZWG" },
//   ];

//   const [selectedCurrency, setSelectedCurrency] = useState(null);
//   const [selectedPack, setSelectedPack] = useState(null);
//   const [packOptions, setPackOptions] = useState([
//     { value: "Daily", label: "Daily" },
//     { value: "Weekly", label: "Weekly" },
//   ]);

//   const [message, setMessage] = useState({
//     state: false,
//     switchTo: "",
//     stayWith: "",
//     msisdn: "",
//   });

//   const [currencyPackLoading, setCurrencyPackLoading] = useState(false);

//   const pressHandler = () => {
//     setModal(false);
//     setModalInfo("");
//     if (modalType === "insufficientBalance") {
//       navigate("/login");
//     }
//   };

//   const submitHandler = async () => {
//     if (msisdn.trim().length === 0 || !selectedCurrency || !selectedPack) {
//       setModal(true);
//       setModalInfo("Input Fields cannot be empty!");
//     } else {
//       try {
//         setSubscribeLoading(true);
//         const response = await subscribeApi({
//           msisdn: `263${msisdn}`,
//           pack: selectedPack?.value,
//           currency: selectedCurrency?.value,
//         });
//         console.log("res insub,", response);
//         if (response.status == 403) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (response.status == 200) {
//           setCookieUserId(response?.data.userId);
//           setTimeout(() => {
//             navigate("/otp", {
//               state: {
//                 msisdn: msisdn,
//                 pack: selectedPack?.value,
//                 currency: selectedCurrency?.value,
//               },
//             });
//           }, 1000);
//         } else if (response?.data.response == 0) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (response?.data.response == 3) {
//           setTimeout(() => {
//             navigate("/otp", {
//               state: {
//                 msisdn: `263${msisdn}`,
//                 pack: selectedPack?.value,
//                 currency: selectedCurrency?.value,
//               },
//             });
//           }, 1000);
//         } else if (response.status === 409) {
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           return;
//         } else {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         }
//         setSubscribeLoading(false);
//       } catch (error) {
//         setSubscribeLoading(false);

//         if (error?.response.status == 403) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (error?.response.status === 409) {
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           return;
//         } else {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         }
//       }
//     }
//   };

//   const navigate = useNavigate();
//   const navigateHandler = (path) => {
//     navigate(path);
//   };

//   const inputRef = useRef(null);

//   const handleCurrencyChange = (selectedOption) => {
//     if (msisdn.trim().length === 0) {
//       inputRef.current.focus();
//       toast.info("Please enter the number first!");
//       return;
//     }
//     setSelectedPack(null);
//     setSelectedCurrency(selectedOption);
//     fetchCurrenyPacks(selectedOption?.value);
//   };

//   // console.log(selectedCurrency, "sc");

//   const fetchCurrenyPacks = async (currencyValue) => {
//   try {
//     setCurrencyPackLoading(true);
//     const response = await getCurrencyPackApi(currencyValue);
//     setCurrencyPackLoading(false);
//     setPackOptions(
//       response?.data?.map((dataItem) => {
//         return {
//           value: dataItem?.pack,
//           label: `${dataItem?.pack} - ${dataItem?.currency === "USD" ? "$" : ""}${dataItem?.price}${dataItem?.currency !== "USD" ? " " + dataItem?.currency : ""}`,
//           price: dataItem?.price,
//           currency: dataItem?.currency
//         };
//       })
//     );
//   } catch (error) {
//     setCurrencyPackLoading(false);
//    toast.error(
//   error?.response?.data?.message ||
//     error?.message ||
//     "An unexpected error occurred"
// );
//   }
// };

//   const handleReset = () => {
//     setMessage({
//       state: false,
//       switchTo: "",
//       stayWith: "",
//       msisdn: "",
//     });
//   };

//   const loginApiHandler = async (currencyFromParam) => {
//     try {
//       console.log(currencyFromParam, "cfp");
//       setLoading(true);
//       const response = await loginApi({
//         msisdn: `263${msisdn}`,
//         currency: currencyFromParam,
//       });
//       console.log(response);

//       const responseData = response?.data;
//       const responseStatus = response?.status;

//       switch (responseStatus) {
//         case 200:
//           if (responseData === "Login successful. OTP sent.") {
//             navigate("/otp", {
//               state: {
//                 msisdn: msisdn,
//                 pack: null,
//                 currency: currencyFromParam,
//               },
//             });
//           } else {
//             setModal(true);
//             setModalInfo(responseData || "Success");
//           }
//           break;

//         case 403:
//           setModal(true);
//           setModalType("insufficientBalance");
//           setModalInfo(
//             "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//           );
//           break;

//         case 404:
//           setModal(true);
//           setModalInfo("User not found. Please subscribe to access services.");
//           break;

//         case 402:
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance!");
//           break;

//         case 409:
//           console.log("enter here...");
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           break;

//         default:
//           setModal(true);
//           setModalInfo("An unexpected error occurred.");
//       }

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       if (error?.response?.status === 403) {
//         setModal(true);
//         setModalType("insufficientBalance");
//         setModalInfo(
//           "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//         );
//       } else if (error?.response?.status === 404) {
//         setModal(true);
//         setModalInfo("Subscription not found. Please subscribe the services.");
//       } else if (error?.response?.status === 402) {
//         setModal(true);
//         setModalInfo("Oops, you have insufficient balance!");
//       } else if (error?.response?.status === 409) {
//         console.log("enter here 2");
//         let optionUserIsSubscribed = currencyOptions.filter(
//           (data) => data?.value != selectedCurrency?.value
//         );
//         setMessage({
//           state: true,
//           switchTo: selectedCurrency?.value,
//           stayWith:
//             optionUserIsSubscribed.length > 0 &&
//             optionUserIsSubscribed[0]?.value,
//           msisdn: msisdn,
//         });
//       } else {
//         setModal(true);
//         setModalInfo(
//           error?.response?.data?.message ||
//             error?.message ||
//             "An unexpected error occurred."
//         );
//       }
//     }
//   };

//   const handlingResponseforChange = (response) => {
//     console.log("response: ", response);
//     const { status, data } = response;

//     console.log("response..", status);
//     console.log("data..", data);

//     switch (status) {
//       case 200:
//       case 202:
//         toast.success("Currency Changed successfully");
//         setMessage({
//           state: false,
//         });
//         loginApiHandler(message.switchTo);
//         break;

//       case 500:
//       case "Network Error":
//         setLoading(false);
//         navigate("/error");
//         break;

//       case 409:
//         setLoading(false);
//         let optionUserIsSubscribed = currencyOptions.filter(
//           (data) => data?.value != selectedCurrency?.value
//         );
//         setMessage({
//           state: true,
//           switchTo: selectedCurrency?.value,
//           stayWith:
//             optionUserIsSubscribed.length > 0 &&
//             optionUserIsSubscribed[0]?.value,
//           msisdn: msisdn,
//         });
//         break;

//       case 404:
//         setLoading(false);
//         setModal(true);
//         setModalInfo("An unexpected error occurred.");
//         break;

//       case 402:
//         console.log("402----", status);
//         setLoading(false);
//         toast.error(data);
//         setModal(true);
//         setModalInfo(response.data.message);
//         setTimeout(() => {
//           navigate("/login");
//         }, 2000);
//         break;

//       case 403:
//         setLoading(false);
//         setModal(true);
//         setModalType("insufficientBalance");
//         setModalInfo(
//           "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//         );
//         break;

//       default:
//         setLoading(false);
//         break;
//     }
//   };

//   const handleChangeCurrency = async () => {
//     console.log(message.switchTo);
//     let request = {
//       msisdn: `263${message.msisdn}`,
//       currency: message.switchTo,
//       pack: selectedPack.value,
//     };

//     const response = await changeCurrencyApi(request);
//     handlingResponseforChange(response);
//   };

//   const handlewithsame = async (currencyFromParam) => {
//     toast.error(`You are already subscribed with ${message.stayWith}`);

//     loginApiHandler(currencyFromParam);
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         backgroundColor: "#000",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "flex-start",
//         margin: 0,
//         padding: 0,
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           maxWidth: "430px",
//           minHeight: "100vh",
//           backgroundColor: "#fff",
//           display: "flex",
//           flexDirection: "column",
//           position: "relative",
//         }}
//       >
//         {message?.state == true ? (
//           <div
//             style={{
//               padding: "24px",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <button
//               onClick={handleReset}
//               style={{
//                 alignSelf: "flex-start",
//                 fontSize: "24px",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               &#8617;
//             </button>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "16px",
//               }}
//             >
//               <p
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   textAlign: "center",
//                 }}
//               >
//                 YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}
//               </p>
//               <p
//                 style={{
//                   fontSize: "16px",
//                   textAlign: "center",
//                 }}
//               >
//                 DO YOU WISH TO:
//               </p>
//               <button
//                 type="button"
//                 disabled={loading}
//                 onClick={() => handleChangeCurrency()}
//                 style={{
//                   padding: "14px",
//                   backgroundColor: "#000",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: "8px",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                 }}
//               >
//                 {`SWITCH TO ${message.switchTo}`}
//               </button>
//               <button
//                 type="button"
//                 disabled={loading}
//                 onClick={() => handlewithsame(message.stayWith)}
//                 style={{
//                   padding: "14px",
//                   backgroundColor: "#f0f0f0",
//                   color: "#000",
//                   border: "none",
//                   borderRadius: "8px",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                 }}
//               >
//                 {`STAY WITH ${message.stayWith}`}
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div
//             style={{
//               padding: "40px 24px",
//               display: "flex",
//               flexDirection: "column",
//               flex: 1,
//             }}
//           >
//             <h1
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 margin: "0 0 32px 0",
//                 color: "#000",
//               }}
//             >
//               Subscribe
//             </h1>

//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "24px",
//                 marginBottom: "auto",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#000",
//                   }}
//                 >
//                   Phone number
//                 </label>
//                 <div style={{
//   position: 'relative',
//   display: 'flex',
//   alignItems: 'center'
// }}>
//   <span style={{
//     position: 'absolute',
//     left: '14px',
//     fontSize: '16px',
//     color: '#666',
//     pointerEvents: 'none'
//   }}>
//     +263
//   </span>
//   <input
//     ref={inputRef}
//     type="number"
//     placeholder="778106925"
//     value={msisdn}
//     onChange={(e) => setMsisdn(e.target.value)}
//     style={{
//       width: "100%",
//       padding: "14px 14px 14px 60px",
//       fontSize: "16px",
//       border: "1px solid #e0e0e0",
//       borderRadius: "8px",
//       outline: "none",
//       boxSizing: "border-box",
//     }}
//   />
// </div>
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#000",
//                   }}
//                 >
//                   Choose Currency
//                 </label>
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "8px",
//                   }}
//                 >
//                   {currencyOptions.map((currency) => (
//                     <button
//                       key={currency.value}
//                       type="button"
//                       onClick={() => handleCurrencyChange(currency)}
//                       style={{
//                         flex: 1,
//                         padding: "12px",
//                         backgroundColor:
//                           selectedCurrency?.value === currency.value
//                             ? "#e8e4ff"
//                             : "#fff",
//                         color: "#000",
//                         border: "1px solid #e0e0e0",
//                         borderRadius: "8px",
//                         fontSize: "14px",
//                         fontWeight: "500",
//                         cursor: "pointer",
//                       }}
//                     >
//                       {currency.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               {selectedCurrency && (
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "8px",
//                   }}
//                 >
//                   <label
//                     style={{
//                       fontSize: "14px",
//                       fontWeight: "500",
//                       color: "#000",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <span>Select a package of your choice</span>
//                     <span style={{ fontSize: "18px", cursor: "pointer" }}>

//                     </span>
//                   </label>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px",
//                     }}
//                   >
//                     {packOptions.map((pack) => (
//                       <button
//                         key={pack.value}
//                         type="button"
//                         onClick={() => setSelectedPack(pack)}
//                         style={{
//                           padding: "12px",
//                           backgroundColor:
//                             selectedPack?.value === pack.value
//                               ? "#e8e4ff"
//                               : "#fff",
//                           color: "#000",
//                           border: "1px solid #e0e0e0",
//                           borderRadius: "8px",
//                           fontSize: "14px",
//                           fontWeight: "500",
//                           cursor: "pointer",
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                         }}
//                       >
//                         <span>{pack.label}</span>
//                         {selectedPack?.value === pack.value && (
//                           <span>✓</span>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {selectedPack && (
//                 <button
//                   type="button"
//                   onClick={submitHandler}
//                   style={{
//                     width: "100%",
//                     padding: "16px",
//                     backgroundColor: "#000",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "8px",
//                     fontSize: "16px",
//                     fontWeight: "600",
//                     cursor: "pointer",
//                     marginTop: "8px",
//                   }}
//                 >
//                   Subscribe
//                 </button>
//               )}
//             </div>

//             <div
//               style={{
//                 textAlign: "center",
//                 fontSize: "14px",
//                 color: "#666",
//                 paddingTop: "40px",
//                 paddingBottom: "40px",
//               }}
//             >
//               Already have a subscription?{" "}
//               <span
//                 onClick={() => navigateHandler("/login")}
//                 style={{
//                   color: "#000",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   textDecoration: "underline",
//                 }}
//               >
//                 Log in
//               </span>
//             </div>
//           </div>
//         )}

//         {subscribeLoading && <Loader />}
//         {loading && <Loader />}
//         {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
//       </div>
//     </div>
//   );
// };

// export default SubscriptionPage;

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   changeCurrencyApi,
//   getCurrencyPackApi,
//   loginApi,
//   priceApi,
//   subscribeApi,
// } from "../http/http";
// import ModalInfo from "../components/ModalInfo";
// import Loader from "../components/Loader";
// import { setCookie, setCookieUserId } from "../utils/helper";

// const SubscriptionPage = () => {
//   const [msisdn, setMsisdn] = useState("");
//   const [modal, setModal] = useState(false);
//   const [modalInfo, setModalInfo] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [subscribeLoading, setSubscribeLoading] = useState(false);
//   const [modalType, setModalType] = useState("");
//   const currencyOptions = [
//     { value: "USD", label: "USD" },
//     { value: "ZWG", label: "ZWG" },
//   ];

//   const [selectedCurrency, setSelectedCurrency] = useState(null);
//   const [selectedPack, setSelectedPack] = useState(null);
//   const [packOptions, setPackOptions] = useState([
//     { value: "Daily", label: "Daily" },
//     { value: "Weekly", label: "Weekly" },
//   ]);

//   const [message, setMessage] = useState({
//     state: false,
//     switchTo: "",
//     stayWith: "",
//     msisdn: "",
//   });

//   const [currencyPackLoading, setCurrencyPackLoading] = useState(false);

//   // Helper function to extract string message from response
//   const extractMessage = (data) => {
//     if (typeof data === 'string') {
//       return data;
//     }
//     if (data && typeof data === 'object') {
//       return data.message || data.error || JSON.stringify(data);
//     }
//     return "An unexpected error occurred";
//   };

//   const pressHandler = () => {
//     setModal(false);
//     setModalInfo("");
//     if (modalType === "insufficientBalance") {
//       navigate("/login");
//     }
//   };

//   const submitHandler = async () => {
//     if (msisdn.trim().length === 0 || !selectedCurrency || !selectedPack) {
//       setModal(true);
//       setModalInfo("Input Fields cannot be empty!");
//     } else {
//       try {
//         setSubscribeLoading(true);
//         const response = await subscribeApi({
//           msisdn: `263${msisdn}`,
//           pack: selectedPack?.value,
//           currency: selectedCurrency?.value,
//         });
//         console.log("res insub,", response);
//         if (response.status == 403) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (response.status == 200) {
//           setCookieUserId(response?.data.userId);
//           setTimeout(() => {
//             navigate("/otp", {
//               state: {
//                 msisdn: msisdn,
//                 pack: selectedPack?.value,
//                 currency: selectedCurrency?.value,
//               },
//             });
//           }, 1000);
//         } else if (response?.data.response == 0) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (response?.data.response == 3) {
//           setTimeout(() => {
//             navigate("/otp", {
//               state: {
//                 msisdn: `263${msisdn}`,
//                 pack: selectedPack?.value,
//                 currency: selectedCurrency?.value,
//               },
//             });
//           }, 1000);
//         } else if (response.status === 409) {
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           return;
//         } else {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         }
//         setSubscribeLoading(false);
//       } catch (error) {
//         setSubscribeLoading(false);

//         if (error?.response.status == 403) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (error?.response.status === 409) {
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           return;
//         } else {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         }
//       }
//     }
//   };

//   const navigate = useNavigate();
//   const navigateHandler = (path) => {
//     navigate(path);
//   };

//   const inputRef = useRef(null);

//   const handleCurrencyChange = (selectedOption) => {
//     if (msisdn.trim().length === 0) {
//       inputRef.current.focus();
//       toast.info("Please enter the number first!");
//       return;
//     }
//     setSelectedPack(null);
//     setSelectedCurrency(selectedOption);
//     fetchCurrenyPacks(selectedOption?.value);
//   };

//   // console.log(selectedCurrency, "sc");

//   const fetchCurrenyPacks = async (currencyValue) => {
//     try {
//       setCurrencyPackLoading(true);
//       const response = await getCurrencyPackApi(currencyValue);
//       setCurrencyPackLoading(false);
//       setPackOptions(
//         response?.data?.map((dataItem) => {
//           return {
//             value: dataItem?.pack,
//             label: `${dataItem?.pack} - ${dataItem?.currency === "USD" ? "$" : ""}${dataItem?.price}${dataItem?.currency !== "USD" ? " " + dataItem?.currency : ""}`,
//             price: dataItem?.price,
//             currency: dataItem?.currency
//           };
//         })
//       );
//     } catch (error) {
//       setCurrencyPackLoading(false);
//       toast.error(
//         error?.response?.data?.message ||
//           error?.message ||
//           "An unexpected error occurred"
//       );
//     }
//   };

//   const handleReset = () => {
//     setMessage({
//       state: false,
//       switchTo: "",
//       stayWith: "",
//       msisdn: "",
//     });
//   };

//   const loginApiHandler = async (currencyFromParam) => {
//     try {
//       console.log(currencyFromParam, "cfp");
//       setLoading(true);
//       const response = await loginApi({
//         msisdn: `263${msisdn}`,
//         currency: currencyFromParam,
//       });
//       console.log(response);

//       const responseData = response?.data;
//       console.log(responseData)
//       const responseStatus = response?.status;

//       switch (responseStatus) {
//         case 200:
//           console.log("responseData:", responseData, typeof responseData);
//           if (responseData.statusCode === "200") {
//             navigate("/otp", {
//               state: {
//                 msisdn: msisdn,
//                 pack: null,
//                 currency: currencyFromParam,
//               },
//             });
//           } else {
//             setModal(true);
//             setModalInfo(extractMessage(responseData) || "Success");
//           }
//           break;

//         case 403:
//           setModal(true);
//           setModalType("insufficientBalance");
//           setModalInfo(
//             "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//           );
//           break;

//         case 404:
//           setModal(true);
//           setModalInfo("User not found. Please subscribe to access services.");
//           break;

//         case 402:
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance!");
//           break;

//         case 409:
//           console.log("enter here...");
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           break;

//         default:
//           setModal(true);
//           setModalInfo("An unexpected error occurred.");
//       }

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       if (error?.response?.status === 403) {
//         setModal(true);
//         setModalType("insufficientBalance");
//         setModalInfo(
//           "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//         );
//       } else if (error?.response?.status === 404) {
//         setModal(true);
//         setModalInfo("Subscription not found. Please subscribe the services.");
//       } else if (error?.response?.status === 402) {
//         setModal(true);
//         setModalInfo("Oops, you have insufficient balance!");
//       } else if (error?.response?.status === 409) {
//         console.log("enter here 2");
//         let optionUserIsSubscribed = currencyOptions.filter(
//           (data) => data?.value != selectedCurrency?.value
//         );
//         setMessage({
//           state: true,
//           switchTo: selectedCurrency?.value,
//           stayWith:
//             optionUserIsSubscribed.length > 0 &&
//             optionUserIsSubscribed[0]?.value,
//           msisdn: msisdn,
//         });
//       } else {
//         setModal(true);
//         setModalInfo(
//           error?.response?.data?.message ||
//             error?.message ||
//             "An unexpected error occurred."
//         );
//       }
//     }
//   };

//   const handlingResponseforChange = (response) => {
//     console.log("response: ", response);
//     const { status, data } = response;

//     console.log("response..", status);
//     console.log("data..", data);

//     switch (status) {
//       case 200:
//       case 202:
//         toast.success("Currency Changed successfully");
//         setMessage({
//           state: false,
//         });
//         loginApiHandler(message.switchTo);
//         break;

//       case 500:
//       case "Network Error":
//         setLoading(false);
//         navigate("/error");
//         break;

//       case 409:
//         setLoading(false);
//         let optionUserIsSubscribed = currencyOptions.filter(
//           (data) => data?.value != selectedCurrency?.value
//         );
//         setMessage({
//           state: true,
//           switchTo: selectedCurrency?.value,
//           stayWith:
//             optionUserIsSubscribed.length > 0 &&
//             optionUserIsSubscribed[0]?.value,
//           msisdn: msisdn,
//         });
//         break;

//       case 404:
//         setLoading(false);
//         setModal(true);
//         setModalInfo("An unexpected error occurred.");
//         break;

//       case 402:
//         console.log("402----", status);
//         setLoading(false);
//         toast.error(extractMessage(data));
//         setModal(true);
//         setModalInfo(extractMessage(response.data));
//         setTimeout(() => {
//           navigate("/login");
//         }, 2000);
//         break;

//       case 403:
//         setLoading(false);
//         setModal(true);
//         setModalType("insufficientBalance");
//         setModalInfo(
//           "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//         );
//         break;

//       default:
//         setLoading(false);
//         break;
//     }
//   };

//   const handleChangeCurrency = async () => {
//     console.log(message.switchTo);
//     let request = {
//       msisdn: `263${message.msisdn}`,
//       currency: message.switchTo,
//       pack: selectedPack.value,
//     };

//     const response = await changeCurrencyApi(request);
//     handlingResponseforChange(response);
//   };

//   const handlewithsame = async (currencyFromParam) => {
//     toast.error(`You are already subscribed with ${message.stayWith}`);

//     loginApiHandler(currencyFromParam);
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         backgroundColor: "#000",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "flex-start",
//         margin: 0,
//         padding: 0,
//       }}
//     >
//       <div
//         style={{
//           width: "100%",
//           maxWidth: "430px",
//           minHeight: "100vh",
//           backgroundColor: "#fff",
//           display: "flex",
//           flexDirection: "column",
//           position: "relative",
//         }}
//       >
//         {message?.state == true ? (
//           <div
//             style={{
//               padding: "24px",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <button
//               onClick={handleReset}
//               style={{
//                 alignSelf: "flex-start",
//                 fontSize: "24px",
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               &#8617;
//             </button>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "16px",
//               }}
//             >
//               <p
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   textAlign: "center",
//                 }}
//               >
//                 YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}
//               </p>
//               <p
//                 style={{
//                   fontSize: "16px",
//                   textAlign: "center",
//                 }}
//               >
//                 DO YOU WISH TO:
//               </p>
//               <button
//                 type="button"
//                 disabled={loading}
//                 onClick={() => handleChangeCurrency()}
//                 style={{
//                   padding: "14px",
//                   backgroundColor: "#000",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: "8px",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                 }}
//               >
//                 {`SWITCH TO ${message.switchTo}`}
//               </button>
//               <button
//                 type="button"
//                 disabled={loading}
//                 onClick={() => handlewithsame(message.stayWith)}
//                 style={{
//                   padding: "14px",
//                   backgroundColor: "#f0f0f0",
//                   color: "#000",
//                   border: "none",
//                   borderRadius: "8px",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                 }}
//               >
//                 {`STAY WITH ${message.stayWith}`}
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div
//             style={{
//               padding: "40px 24px",
//               display: "flex",
//               flexDirection: "column",
//               flex: 1,
//             }}
//           >
//             <h1
//               style={{
//                 fontSize: "32px",
//                 fontWeight: "700",
//                 margin: "0 0 32px 0",
//                 color: "#000",
//               }}
//             >
//               Subscribe
//             </h1>

//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "24px",
//                 marginBottom: "auto",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#000",
//                   }}
//                 >
//                   Phone number
//                 </label>
//                 <div style={{
//                   position: 'relative',
//                   display: 'flex',
//                   alignItems: 'center'
//                 }}>
//                   <span style={{
//                     position: 'absolute',
//                     left: '14px',
//                     fontSize: '16px',
//                     color: '#666',
//                     pointerEvents: 'none'
//                   }}>
//                     +263
//                   </span>
//                   <input
//                     ref={inputRef}
//                     type="number"
//                     placeholder="778106925"
//                     value={msisdn}
//                     onChange={(e) => setMsisdn(e.target.value)}
//                     style={{
//                       width: "100%",
//                       padding: "14px 14px 14px 60px",
//                       fontSize: "16px",
//                       border: "1px solid #e0e0e0",
//                       borderRadius: "8px",
//                       outline: "none",
//                       boxSizing: "border-box",
//                     }}
//                   />
//                 </div>
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <label
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#000",
//                   }}
//                 >
//                   Choose Currency
//                 </label>
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "8px",
//                   }}
//                 >
//                   {currencyOptions.map((currency) => (
//                     <button
//                       key={currency.value}
//                       type="button"
//                       onClick={() => handleCurrencyChange(currency)}
//                       style={{
//                         flex: 1,
//                         padding: "12px",
//                         backgroundColor:
//                           selectedCurrency?.value === currency.value
//                             ? "#e8e4ff"
//                             : "#fff",
//                         color: "#000",
//                         border: "1px solid #e0e0e0",
//                         borderRadius: "8px",
//                         fontSize: "14px",
//                         fontWeight: "500",
//                         cursor: "pointer",
//                       }}
//                     >
//                       {currency.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               {selectedCurrency && (
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "8px",
//                   }}
//                 >
//                   <label
//                     style={{
//                       fontSize: "14px",
//                       fontWeight: "500",
//                       color: "#000",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <span>Select a package of your choice</span>
//                     <span style={{ fontSize: "18px", cursor: "pointer" }}>

//                     </span>
//                   </label>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px",
//                     }}
//                   >
//                     {packOptions.map((pack) => (
//                       <button
//                         key={pack.value}
//                         type="button"
//                         onClick={() => setSelectedPack(pack)}
//                         style={{
//                           padding: "12px",
//                           backgroundColor:
//                             selectedPack?.value === pack.value
//                               ? "#e8e4ff"
//                               : "#fff",
//                           color: "#000",
//                           border: "1px solid #e0e0e0",
//                           borderRadius: "8px",
//                           fontSize: "14px",
//                           fontWeight: "500",
//                           cursor: "pointer",
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                         }}
//                       >
//                         <span>{pack.label}</span>
//                         {selectedPack?.value === pack.value && (
//                           <span>✓</span>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {selectedPack && (
//                 <button
//                   type="button"
//                   onClick={submitHandler}
//                   style={{
//                     width: "100%",
//                     padding: "16px",
//                     backgroundColor: "#000",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "8px",
//                     fontSize: "16px",
//                     fontWeight: "600",
//                     cursor: "pointer",
//                     marginTop: "8px",
//                   }}
//                 >
//                   Subscribe
//                 </button>
//               )}
//             </div>

//             <div
//               style={{
//                 textAlign: "center",
//                 fontSize: "14px",
//                 color: "#666",
//                 paddingTop: "40px",
//                 paddingBottom: "40px",
//               }}
//             >
//               Already have a subscription?{" "}
//               <span
//                 onClick={() => navigateHandler("/login")}
//                 style={{
//                   color: "#000",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   textDecoration: "underline",
//                 }}
//               >
//                 Log in
//               </span>
//             </div>
//           </div>
//         )}

//         {subscribeLoading && <Loader />}
//         {loading && <Loader />}
//         {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
//       </div>
//     </div>
//   );
// };

// export default SubscriptionPage;

// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   changeCurrencyApi,
//   getCurrencyPackApi,
//   loginApi,
//   priceApi,
//   subscribeApi,
// } from "../http/http";
// import ModalInfo from "../components/ModalInfo";
// import Loader from "../components/Loader";
// import { setCookie, setCookieUserId } from "../utils/helper";

// const SubscriptionPage = () => {
//   const [msisdn, setMsisdn] = useState("");
//   const [modal, setModal] = useState(false);
//   const [modalInfo, setModalInfo] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [subscribeLoading, setSubscribeLoading] = useState(false);
//   const [modalType, setModalType] = useState("");
//   const currencyOptions = [
//     { value: "USD", label: "USD" },
//     { value: "ZWG", label: "ZWG" },
//   ];

//   const [selectedCurrency, setSelectedCurrency] = useState(null);
//   const [selectedPack, setSelectedPack] = useState(null);
//   const [packOptions, setPackOptions] = useState([
//     { value: "Daily", label: "Daily" },
//     { value: "Weekly", label: "Weekly" },
//   ]);

//   const [message, setMessage] = useState({
//     state: false,
//     switchTo: "",
//     stayWith: "",
//     msisdn: "",
//   });

//   const [currencyPackLoading, setCurrencyPackLoading] = useState(false);

//   const cleanPhoneNumber = (phone) => {
//   let cleaned = phone.replace(/\D/g, '');

//   // Remove leading 263 if user typed it
//   if (cleaned.startsWith('263')) {
//     cleaned = cleaned.slice(3);
//   }

//   // Remove leading 0 (e.g. 0778...)
//   if (cleaned.startsWith('0')) {
//     cleaned = cleaned.slice(1);
//   }

//   return `263${cleaned}`;
// };

//   // Helper function to extract string message from response
//   const extractMessage = (data) => {
//     if (typeof data === 'string') {
//       return data;
//     }
//     if (data && typeof data === 'object') {
//       return data.message || data.error || JSON.stringify(data);
//     }
//     return "An unexpected error occurred";
//   };

//   const pressHandler = () => {
//     setModal(false);
//     setModalInfo("");
//     if (modalType === "insufficientBalance") {
//       navigate("/login");
//     }
//   };

//   const submitHandler = async () => {
//     if (msisdn.trim().length === 0 || !selectedCurrency || !selectedPack) {
//       setModal(true);
//       setModalInfo("Input Fields cannot be empty!");
//     } else {
//       try {
//         setSubscribeLoading(true);
//         const cleanedNumber = cleanPhoneNumber(msisdn);
//         const response = await subscribeApi({
//           msisdn: cleanedNumber,
//           pack: selectedPack?.value,
//           currency: selectedCurrency?.value,
//         });
//         console.log("res insub,", response);
//         if (response.status == 403) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (response.status == 200) {
//           setCookieUserId(response?.data.userId);
//           setTimeout(() => {
//             navigate("/otp", {
//               state: {
//                 msisdn: msisdn,
//                 pack: selectedPack?.value,
//                 currency: selectedCurrency?.value,
//               },
//             });
//           }, 1000);
//         } else if (response?.data.response == 0) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (response?.data.response == 3) {
//           setTimeout(() => {
//             navigate("/otp", {
//               state: {
//                 msisdn: cleanedNumber,
//                 pack: selectedPack?.value,
//                 currency: selectedCurrency?.value,
//               },
//             });
//           }, 1000);
//         } else if (response.status === 409) {
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           return;
//         } else {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         }
//         setSubscribeLoading(false);
//       } catch (error) {
//         setSubscribeLoading(false);

//         if (error?.response.status == 403) {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         } else if (error?.response.status === 409) {
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           return;
//         } else {
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance !!");
//           return;
//         }
//       }
//     }
//   };

//   const navigate = useNavigate();
//   const navigateHandler = (path) => {
//     navigate(path);
//   };

//   const inputRef = useRef(null);

//   const handleCurrencyChange = (selectedOption) => {
//     if (msisdn.trim().length === 0) {
//       inputRef.current.focus();
//       toast.info("Please enter the number first!");
//       return;
//     }
//     setSelectedPack(null);
//     setSelectedCurrency(selectedOption);
//     fetchCurrenyPacks(selectedOption?.value);
//   };

//   const fetchCurrenyPacks = async (currencyValue) => {
//     try {
//       setCurrencyPackLoading(true);
//       const response = await getCurrencyPackApi(currencyValue);
//       setCurrencyPackLoading(false);
//       setPackOptions(
//         response?.data?.map((dataItem) => {
//           return {
//             value: dataItem?.pack,
//             label: `${dataItem?.pack} - ${dataItem?.currency === "USD" ? "$" : ""}${dataItem?.price}${dataItem?.currency !== "USD" ? " " + dataItem?.currency : ""}`,
//             price: dataItem?.price,
//             currency: dataItem?.currency
//           };
//         })
//       );
//     } catch (error) {
//       setCurrencyPackLoading(false);
//       toast.error(
//         error?.response?.data?.message ||
//           error?.message ||
//           "An unexpected error occurred"
//       );
//     }
//   };

//   const handleReset = () => {
//     setMessage({
//       state: false,
//       switchTo: "",
//       stayWith: "",
//       msisdn: "",
//     });
//   };

//   const loginApiHandler = async (currencyFromParam) => {
//     try {
//       console.log(currencyFromParam, "cfp");
//       setLoading(true);
//       const cleanedNumber = cleanPhoneNumber(msisdn);
//       const response = await loginApi({
//         msisdn: cleanedNumber,
//         currency: currencyFromParam,
//       });
//       console.log(response);

//       const responseData = response?.data;
//       console.log(responseData)
//       const responseStatus = response?.status;

//       switch (responseStatus) {
//         case 200:
//           console.log("responseData:", responseData, typeof responseData);
//           if (responseData.statusCode === "200") {
//             navigate("/otp", {
//               state: {
//                 msisdn: msisdn,
//                 pack: null,
//                 currency: currencyFromParam,
//               },
//             });
//           } else {
//             setModal(true);
//             setModalInfo(extractMessage(responseData) || "Success");
//           }
//           break;

//         case 403:
//           setModal(true);
//           setModalType("insufficientBalance");
//           setModalInfo(
//             "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//           );
//           break;

//         case 404:
//           setModal(true);
//           setModalInfo("User not found. Please subscribe to access services.");
//           break;

//         case 402:
//           setModal(true);
//           setModalInfo("Oops, you have insufficient balance!");
//           break;

//         case 409:
//           console.log("enter here...");
//           let optionUserIsSubscribed = currencyOptions.filter(
//             (data) => data?.value != selectedCurrency?.value
//           );
//           setMessage({
//             state: true,
//             switchTo: selectedCurrency?.value,
//             stayWith:
//               optionUserIsSubscribed.length > 0 &&
//               optionUserIsSubscribed[0]?.value,
//             msisdn: msisdn,
//           });
//           break;

//         default:
//           setModal(true);
//           setModalInfo("An unexpected error occurred.");
//       }

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       if (error?.response?.status === 403) {
//         setModal(true);
//         setModalType("insufficientBalance");
//         setModalInfo(
//           "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//         );
//       } else if (error?.response?.status === 404) {
//         setModal(true);
//         setModalInfo("Subscription not found. Please subscribe the services.");
//       } else if (error?.response?.status === 402) {
//         setModal(true);
//         setModalInfo("Oops, you have insufficient balance!");
//       } else if (error?.response?.status === 409) {
//         console.log("enter here 2");
//         let optionUserIsSubscribed = currencyOptions.filter(
//           (data) => data?.value != selectedCurrency?.value
//         );
//         setMessage({
//           state: true,
//           switchTo: selectedCurrency?.value,
//           stayWith:
//             optionUserIsSubscribed.length > 0 &&
//             optionUserIsSubscribed[0]?.value,
//           msisdn: msisdn,
//         });
//       } else {
//         setModal(true);
//         setModalInfo(
//           error?.response?.data?.message ||
//             error?.message ||
//             "An unexpected error occurred."
//         );
//       }
//     }
//   };

//   const handlingResponseforChange = (response) => {
//     console.log("response: ", response);
//     const { status, data } = response;

//     console.log("response..", status);
//     console.log("data..", data);

//     switch (status) {
//       case 200:
//       case 202:
//         toast.success("Currency Changed successfully");
//         setMessage({
//           state: false,
//         });
//         loginApiHandler(message.switchTo);
//         break;

//       case 500:
//       case "Network Error":
//         setLoading(false);
//         navigate("/error");
//         break;

//       case 409:
//         setLoading(false);
//         let optionUserIsSubscribed = currencyOptions.filter(
//           (data) => data?.value != selectedCurrency?.value
//         );
//         setMessage({
//           state: true,
//           switchTo: selectedCurrency?.value,
//           stayWith:
//             optionUserIsSubscribed.length > 0 &&
//             optionUserIsSubscribed[0]?.value,
//           msisdn: msisdn,
//         });
//         break;

//       case 404:
//         setLoading(false);
//         setModal(true);
//         setModalInfo("An unexpected error occurred.");
//         break;

//       case 402:
//         console.log("402----", status);
//         setLoading(false);
//         toast.error(extractMessage(data));
//         setModal(true);
//         setModalInfo(extractMessage(response.data));
//         setTimeout(() => {
//           navigate("/login");
//         }, 2000);
//         break;

//       case 403:
//         setLoading(false);
//         setModal(true);
//         setModalType("insufficientBalance");
//         setModalInfo(
//           "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
//         );
//         break;

//       default:
//         setLoading(false);
//         break;
//     }
//   };

//   const handleChangeCurrency = async () => {
//     console.log(message.switchTo);
//     const cleanedNumber = cleanPhoneNumber(message.msisdn);
//     let request = {
//       msisdn: cleanedNumber,
//       currency: message.switchTo,
//       pack: selectedPack.value,
//     };

//     const response = await changeCurrencyApi(request);
//     handlingResponseforChange(response);
//   };

//   const handlewithsame = async (currencyFromParam) => {
//     toast.error(`You are already subscribed with ${message.stayWith}`);

//     loginApiHandler(currencyFromParam);
//   };

//   return (
//     <div className="min-h-screen bg-black flex justify-center items-start">
//       {/* <div className="w-full max-w-[430px] min-h-screen bg-gradient-to-b from-[#253246] to-[#1e2738] flex flex-col relative"> */}
//       <div className="w-full max-w-[430px] min-h-screen bg-black flex flex-col relative">
//         {message?.state == true ? (
//           <div className="px-6 py-8 flex flex-col gap-10">
//             <button
//               onClick={handleReset}
//               className="self-start text-2xl bg-transparent border-none text-white cursor-pointer"
//             >
//               &#8617;
//             </button>
//             <div className="flex flex-col gap-4 items-center">
//               <p className="text-lg font-semibold text-center text-white">
//                 YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}
//               </p>
//               <p className="text-base text-center text-gray-300">
//                 DO YOU WISH TO:
//               </p>
//               <button
//                 type="button"
//                 disabled={loading}
//                 onClick={() => handleChangeCurrency()}
//                 className="w-full py-4 bg-white text-[#1e2738] border-none rounded-xl text-base font-semibold cursor-pointer shadow-md"
//               >
//                 {`SWITCH TO ${message.switchTo}`}
//               </button>
//               <button
//                 type="button"
//                 disabled={loading}
//                 onClick={() => handlewithsame(message.stayWith)}
//                 className="w-full py-4 bg-transparent text-white border border-gray-400 rounded-xl text-base font-semibold cursor-pointer"
//               >
//                 {`STAY WITH ${message.stayWith}`}
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div className="px-6 py-10 flex flex-col flex-1">
//             {/* Header with Logo */}
//             <div className="flex items-center justify-center mb-8">
//               <img src="econet.png" className="w-48" alt="Econet Logo" />
//             </div>

//             <h1 className="text-3xl font-bold mb-8 text-white text-center">
//               Subscribe Now
//             </h1>

//             <div className="flex flex-col gap-6 mb-auto">
//               {/* Phone Number Input */}
//               <div className="flex flex-col gap-2">
//                 <label className="text-sm font-medium text-gray-300">
//                   Phone number
//                 </label>
//                 <div className="relative flex items-center">
//                   <span className="absolute left-4 text-base text-gray-300 pointer-events-none z-10">
//                     +263
//                   </span>
//                   <input
//                     ref={inputRef}
//                     type="number"
//                     placeholder="778106925"
//                     value={msisdn}
//                     onChange={(e) => setMsisdn(e.target.value)}
//                     className="w-full py-5 pl-16 pr-4 text-lg bg-white/10 backdrop-blur-sm text-white placeholder-gray-400 border border-gray-500 rounded-xl outline-none"
//                   />
//                 </div>
//               </div>

//               {/* Currency Selection */}
//               <div className="flex flex-col gap-2">
//                 <label className="text-sm font-medium text-gray-300">
//                   Choose Currency
//                 </label>
//                 <div className="flex gap-3">
//                   {currencyOptions.map((currency) => (
//                     <button
//                       key={currency.value}
//                       type="button"
//                       onClick={() => handleCurrencyChange(currency)}
//                       className={`flex-1 py-3 rounded-xl text-sm font-medium cursor-pointer transition-all ${
//                         selectedCurrency?.value === currency.value
//                           ? "bg-white text-[#1e2738] shadow-md"
//                           : "bg-white/10 backdrop-blur-sm text-white border border-gray-500"
//                       }`}
//                     >
//                       {currency.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               {/* Package Selection */}
//               {selectedCurrency && (
//                 <div className="flex flex-col gap-2">
//                   <label className="text-sm font-medium text-gray-300 flex justify-between items-center">
//                     <span>Select a package of your choice</span>
//                   </label>
//                   <div className="flex flex-col gap-3">
//                     {packOptions.map((pack) => (
//                       <button
//                         key={pack.value}
//                         type="button"
//                         onClick={() => setSelectedPack(pack)}
//                         className={`p-4 rounded-xl text-sm font-medium cursor-pointer flex justify-between items-center transition-all ${
//                           selectedPack?.value === pack.value
//                             ? "bg-white text-[#1e2738] shadow-md"
//                             : "bg-white/10 backdrop-blur-sm text-white border border-gray-500"
//                         }`}
//                       >
//                         <span>{pack.label}</span>
//                         {selectedPack?.value === pack.value && <span>✓</span>}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Subscribe Button */}
//               {selectedPack && (
//                 <button
//                   type="button"
//                   onClick={submitHandler}
//                   className="w-full py-4 bg-white text-[#1e2738] border-none rounded-xl text-base font-semibold cursor-pointer mt-2 shadow-md"
//                 >
//                   Subscribe
//                 </button>
//               )}
//             </div>

//             {/* Footer */}
//             <div className="text-center text-sm text-gray-300 pt-10 pb-10">
//               Already have a subscription?{" "}
//               <span
//                 onClick={() => navigateHandler("/login")}
//                 className="text-white font-semibold cursor-pointer underline"
//               >
//                 Log in
//               </span>
//             </div>
//           </div>
//         )}

//         {subscribeLoading && <Loader />}
//         {loading && <Loader />}
//         {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
//       </div>
//     </div>
//   );
// };

// export default SubscriptionPage;

import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  changeCurrencyApi,
  getCurrencyPackApi,
  loginApi,
  priceApi,
  subscribeApi,
} from "../http/http";
import ModalInfo from "../components/ModalInfo";
import Loader from "../components/Loader";
import { setCookie, setCookieUserId } from "../utils/helper";

const SubscriptionPage = () => {
  const location = useLocation();
  const [msisdn, setMsisdn] = useState(location.state?.msisdn || "");
  const [modal, setModal] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const [modalType, setModalType] = useState("");
  const currencyOptions = [
    { value: "USD", label: "USD" },
    { value: "ZWG", label: "ZWG" },
  ];

  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedPack, setSelectedPack] = useState(null);
  const [packOptions, setPackOptions] = useState([
    { value: "Daily", label: "Daily" },
    { value: "Weekly", label: "Weekly" },
  ]);

  const [message, setMessage] = useState({
    state: false,
    switchTo: "",
    stayWith: "",
    msisdn: "",
  });

  const [currencyPackLoading, setCurrencyPackLoading] = useState(false);

  const cleanPhoneNumber = (phone) => {
    let cleaned = phone.replace(/\D/g, "");

    // Remove leading 263 if user typed it
    if (cleaned.startsWith("263")) {
      cleaned = cleaned.slice(3);
    }

    // Remove leading 0 (e.g. 0778...)
    if (cleaned.startsWith("0")) {
      cleaned = cleaned.slice(1);
    }

    return `263${cleaned}`;
  };

  // Helper function to extract string message from response
  const extractMessage = (data) => {
    if (typeof data === "string") {
      return data;
    }
    if (data && typeof data === "object") {
      return data.message || data.error || JSON.stringify(data);
    }
    return "An unexpected error occurred";
  };

  const pressHandler = () => {
    setModal(false);
    setModalInfo("");
    if (modalType === "insufficientBalance") {
      navigate("/login");
    }
  };

  const submitHandler = async () => {
    if (msisdn.trim().length === 0 || !selectedCurrency || !selectedPack) {
      setModal(true);
      setModalInfo("Input Fields cannot be empty!");
    } else {
      try {
        setSubscribeLoading(true);
        const cleanedNumber = cleanPhoneNumber(msisdn);
        const response = await subscribeApi({
          msisdn: cleanedNumber,
          pack: selectedPack?.value,
          currency: selectedCurrency?.value,
        });
        console.log("res insub,", response);
        if (response.status == 403) {
          setModal(true);
          setModalType("insufficientBalance");
          setModalInfo("Oops, you have insufficient balance !!");
          return;
        } else if (response.status == 200) {
          // setCookieUserId(response?.data.userId);
          const deviceId = Math.floor(10000000 + Math.random() * 90000000).toString();
          setTimeout(() => {
            navigate("/otp", {
              state: {
                msisdn: msisdn,
                pack: selectedPack?.value,
                currency: selectedCurrency?.value,
                fromSubscription: true,
                deviceId:deviceId
              },
            });
          }, 1000);
        } else if (response?.data.response == 0) {
          setModal(true);
          setModalInfo("Oops, you have insufficient balance !!");
          return;
        } else if (response?.data.response == 3) {
          setTimeout(() => {
            navigate("/otp", {
              state: {
                msisdn: cleanedNumber,
                pack: selectedPack?.value,
                currency: selectedCurrency?.value,
              },
            });
          }, 1000);
        } else if (response.status === 409) {
          let optionUserIsSubscribed = currencyOptions.filter(
            (data) => data?.value != selectedCurrency?.value,
          );
          setMessage({
            state: true,
            switchTo: selectedCurrency?.value,
            stayWith:
              optionUserIsSubscribed.length > 0 &&
              optionUserIsSubscribed[0]?.value,
            msisdn: msisdn,
          });
          return;
        } else {
          setModal(true);
          setModalInfo("Oops, you have insufficient balance !!");
          return;
        }
        setSubscribeLoading(false);
      } catch (error) {
        setSubscribeLoading(false);

        if (error?.response.status == 403) {
          setModal(true);
          setModalType("insufficientBalance");
          setModalInfo("Oops, you have insufficient balance !!");
          return;
        } else if (error?.response.status === 409) {
          let optionUserIsSubscribed = currencyOptions.filter(
            (data) => data?.value != selectedCurrency?.value,
          );
          setMessage({
            state: true,
            switchTo: selectedCurrency?.value,
            stayWith:
              optionUserIsSubscribed.length > 0 &&
              optionUserIsSubscribed[0]?.value,
            msisdn: msisdn,
          });
          return;
        } else {
          setModal(true);
          setModalInfo("Oops, you have insufficient balance !!");
          return;
        }
      }
    }
  };

  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };

  const inputRef = useRef(null);

  const handleCurrencyChange = (selectedOption) => {
    if (msisdn.trim().length === 0) {
      inputRef.current.focus();
      toast.info("Please enter the number first!");
      return;
    }
    setSelectedPack(null);
    setSelectedCurrency(selectedOption);
    fetchCurrenyPacks(selectedOption?.value);
  };

  const fetchCurrenyPacks = async (currencyValue) => {
    try {
      setCurrencyPackLoading(true);
      const response = await getCurrencyPackApi(currencyValue);
      setCurrencyPackLoading(false);
      setPackOptions(
        response?.data?.map((dataItem) => {
          return {
            value: dataItem?.pack,
            label: `${dataItem?.pack} - ${dataItem?.currency === "USD" ? "$" : ""}${dataItem?.price}${dataItem?.currency !== "USD" ? " " + dataItem?.currency : ""}`,
            price: dataItem?.price,
            currency: dataItem?.currency,
          };
        }),
      );
    } catch (error) {
      setCurrencyPackLoading(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred",
      );
    }
  };

  const handleReset = () => {
    setMessage({
      state: false,
      switchTo: "",
      stayWith: "",
      msisdn: "",
    });
  };

  const loginApiHandler = async (currencyFromParam) => {
    try {
      // console.log(currencyFromParam, "cfp");
      setLoading(true);
      const cleanedNumber = cleanPhoneNumber(msisdn);
      const response = await loginApi({
        msisdn: cleanedNumber,
        currency: currencyFromParam,
      });
      // console.log(response);

      const responseData = response?.data;
      // console.log(responseData);
      const responseStatus = response?.status;

      switch (responseStatus) {
        case 200:
          // console.log("responseData:", responseData, typeof responseData);
          if (responseData.statusCode === "200") {
            navigate("/otp", {
              state: {
                msisdn: msisdn,
                pack: null,
                currency: currencyFromParam,
              },
            });
          } else {
            setModal(true);
            setModalInfo(extractMessage(responseData) || "Success");
          }
          break;

        case 403:
          setModal(true);
          setModalType("insufficientBalance");
          setModalInfo(
            "Looks like your balance is low. Please top up your airtime to continue enjoying our service.",
          );
          break;

        case 404:
          setModal(true);
          setModalInfo("User not found. Please subscribe to access services.");
          break;

        case 402:
          setModal(true);
          setModalInfo("Oops, you have insufficient balance!");
          break;

        case 409:
          // console.log("enter here...");
          let optionUserIsSubscribed = currencyOptions.filter(
            (data) => data?.value != selectedCurrency?.value,
          );
          setMessage({
            state: true,
            switchTo: selectedCurrency?.value,
            stayWith:
              optionUserIsSubscribed.length > 0 &&
              optionUserIsSubscribed[0]?.value,
            msisdn: msisdn,
          });
          break;

        default:
          setModal(true);
          setModalInfo("An unexpected error occurred.");
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error?.response?.status === 403) {
        setModal(true);
        setModalType("insufficientBalance");
        setModalInfo(
          "Looks like your balance is low. Please top up your airtime to continue enjoying our service.",
        );
      } else if (error?.response?.status === 404) {
        setModal(true);
        setModalInfo("Subscription not found. Please subscribe the services.");
      } else if (error?.response?.status === 402) {
        setModal(true);
        setModalInfo("Oops, you have insufficient balance!");
      } else if (error?.response?.status === 409) {
        // console.log("enter here 2");
        let optionUserIsSubscribed = currencyOptions.filter(
          (data) => data?.value != selectedCurrency?.value,
        );
        setMessage({
          state: true,
          switchTo: selectedCurrency?.value,
          stayWith:
            optionUserIsSubscribed.length > 0 &&
            optionUserIsSubscribed[0]?.value,
          msisdn: msisdn,
        });
      } else {
        setModal(true);
        setModalInfo(
          error?.response?.data?.message ||
            error?.message ||
            "An unexpected error occurred.",
        );
      }
    }
  };

  const handlingResponseforChange = (response) => {
    // console.log("response: ", response);
    const { status, data } = response;

    // console.log("response..", status);
    // console.log("data..", data);

    switch (status) {
      case 200:
      case 202:
        toast.success("Currency Changed successfully");
        setMessage({
          state: false,
        });
        loginApiHandler(message.switchTo);
        break;

      case 500:
      case "Network Error":
        setLoading(false);
        navigate("/error");
        break;

      case 409:
        setLoading(false);
        let optionUserIsSubscribed = currencyOptions.filter(
          (data) => data?.value != selectedCurrency?.value,
        );
        setMessage({
          state: true,
          switchTo: selectedCurrency?.value,
          stayWith:
            optionUserIsSubscribed.length > 0 &&
            optionUserIsSubscribed[0]?.value,
          msisdn: msisdn,
        });
        break;

      case 404:
        setLoading(false);
        setModal(true);
        setModalInfo("An unexpected error occurred.");
        break;

      case 402:
        // console.log("402----", status);
        setLoading(false);
        toast.error(extractMessage(data));
        setModal(true);
        setModalInfo(extractMessage(response.data));
        setTimeout(() => {
          navigate("/login");
        }, 2000);
        break;

      case 403:
        setLoading(false);
        setModal(true);
        setModalType("insufficientBalance");
        setModalInfo(
          "Looks like your balance is low. Please top up your airtime to continue enjoying our service.",
        );
        break;

      default:
        setLoading(false);
        break;
    }
  };

  // const handleChangeCurrency = async () => {
  //   // console.log(message.switchTo);
  //   const cleanedNumber = cleanPhoneNumber(message.msisdn);
  //   let request = {
  //     msisdn: cleanedNumber,
  //     currency: message.switchTo,
  //     pack: selectedPack.value,
  //   };

  //   const response = await changeCurrencyApi(request);
  //   handlingResponseforChange(response);
  // };

  // const handlewithsame = async (currencyFromParam) => {
  //   toast.error(`You are already subscribed with ${message.stayWith}`);

  //   loginApiHandler(currencyFromParam);
  // };




  const handleChangeCurrency = async () => {
  try {
    const cleanedNumber = cleanPhoneNumber(message.msisdn);
    const request = {
      msisdn: cleanedNumber,
      currency: message.switchTo,
      pack: selectedPack?.value,
    };

    const response = await changeCurrencyApi(request);

    if (response.status === 200 || response.status === 202) {
      const deviceId = Math.floor(10000000 + Math.random() * 90000000).toString();
      navigate("/otp", {
        state: {
          msisdn: message.msisdn,
          pack: selectedPack?.value,
          currency: message.switchTo,
          fromSubscription: true,   // ✅
          deviceId: deviceId,
        }
      });
    } else {
      handlingResponseforChange(response);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong.");
  }
};


const handlewithsame = async (currencyFromParam) => {
  const deviceId = Math.floor(10000000 + Math.random() * 90000000).toString();
  try {
    setLoading(true);
    const cleanedNumber = cleanPhoneNumber(msisdn);

    const response = await loginApi({
      msisdn: cleanedNumber,
      currency: currencyFromParam,
       deviceId: deviceId,
    });

    if (response.status === 200 && response.data?.statusCode === "200") {
      
      navigate("/otp", {
        state: {
          msisdn: msisdn,
          pack: selectedPack?.value,
          currency: currencyFromParam,
          fromSubscription: false,   // ✅
          deviceId: deviceId,
        }
      });
    } else {
      setModal(true);
      setModalInfo(extractMessage(response.data) || "An error occurred.");
    }
  } catch (error) {
    setModal(true);
    setModalInfo(error?.response?.data?.message || "Something went wrong.");
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="min-h-screen bg-white flex flex-col md:block">
  {/* Mobile view - unchanged */}
  <div className="md:hidden w-full max-w-[430px] min-h-screen bg-white flex flex-col relative mx-auto">
    {message?.state == true ? (
      <div className="px-6 py-8 flex flex-col gap-10">
        <button
          onClick={handleReset}
          className="self-start text-2xl bg-transparent border-none text-black cursor-pointer"
        >
          &#8617;
        </button>
        <div className="flex flex-col gap-4 items-center">
          <p className="text-lg font-semibold text-center text-black">
            YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}
          </p>
          <p className="text-base text-center text-gray-300">
            DO YOU WISH TO:
          </p>
          <button
            type="button"
            disabled={loading}
            onClick={() => handleChangeCurrency()}
            className="w-full py-4 bg-white text-[#1e2738] border-none rounded-xl text-base font-semibold cursor-pointer shadow-md"
          >
            {`SWITCH TO ${message.switchTo}`}
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={() => handlewithsame(message.stayWith)}
            className="w-full py-4 bg-transparent text-black border border-gray-400 rounded-xl text-base font-semibold cursor-pointer"
          >
            {`STAY WITH ${message.stayWith}`}
          </button>
        </div>
      </div>
    ) : (
      <div className="px-6 py-8 flex justify-center items-center">
        <div className="h-[80vh] flex flex-col  max-w-[320px] mx-auto w-full">
        <div className="flex items-center justify-between gap-4 mb-10 w-full mt-4 px-2">
          <img src="/yogamezxr.png" style={{ mixBlendMode: 'multiply' }} className="h-8 sm:h-12 w-auto object-contain max-w-[45%]" alt="YoGamesXR Logo" />
          <img src="/assets/images/econet_logo.png" className="h-8 sm:h-12 w-auto object-contain max-w-[45%]" alt="Econet Logo" />
        </div>
        <div className="mb-8">
          <h1 className="text-[28px] font-bold text-[#3CB8D4] mb-2">
            Choose your power!
          </h1>
          <p className="text-black text-2xl font-bold">
            Select subscription package.
          </p>
        </div>
        <div className="flex flex-col gap-6 mb-auto">
          <div className="flex flex-col gap-2">
            <label className="text-2xl font-normal text-black">
              Phone number
            </label>
            <div className="relative flex items-center">
              <span className="absolute left-4 text-base text-gray-500 pointer-events-none z-10">
                +263
              </span>
              <input
                ref={inputRef}
                type="tel"
                placeholder="778106925"
                value={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                className="w-full py-4 pl-16 pr-4 text-base bg-[#D8DADC] text-black placeholder-gray-500 border-none rounded-lg outline-none"
              />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-xl font-normal text-black">
              Choose Currency
            </label>
            <div className="flex gap-0 bg-[#E5E5E5] rounded-lg border-black">
              {currencyOptions.map((currency) => (
                <button
                  key={currency.value}
                  type="button"
                  onClick={() => handleCurrencyChange(currency)}
                  className={`flex-1 py-3 rounded-md text-base font-medium cursor-pointer transition-all ${
                    selectedCurrency?.value === currency.value
                      ? "bg-[#3CB8D4] text-black shadow-sm"
                      : "bg-transparent text-gray-600"
                  }`}
                >
                  {currency.label}
                </button>
              ))}
            </div>
          </div>
          {selectedCurrency && (
            <div className="flex flex-col gap-2">
              <label className="text-sm font-normal text-black flex justify-between items-center border-b py-2">
                <span>Select a package of your choice</span>
                <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              </label>
              <div className="flex flex-col justify-center items-center gap-0 bg-white">
                {packOptions.map((pack, index) => (
                  <button
                    key={pack.value}
                    type="button"
                    onClick={() => setSelectedPack(pack)}
                    className={`relative w-[80%] px-4 py-6 text-sm font-normal cursor-pointer
                      flex items-center transition-all border-b border-gray-700 ${
                        selectedPack?.value === pack.value
                          ? "bg-[#D8DADC] text-black"
                          : "bg-white text-black"
                      } ${index === 0 ? "rounded-t-none" : ""}
                      ${index === packOptions.length - 1 ? "rounded-b-none border-b-0" : ""}`}
                  >
                    <span className="absolute left-1/2 -translate-x-1/2">{pack.label}</span>
                    {selectedPack?.value === pack.value && (
                      <svg className="absolute right-4 w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}
          {selectedPack && (
            <button
              type="button"
              onClick={submitHandler}
              className="w-full py-4 bg-[#00D9FF] text-black border-none rounded-lg text-base font-semibold cursor-pointer mt-4"
            >
              Subscribe
            </button>
          )}
        </div>
        <div className="text-center text-xl text-black pt-8 pb-6">
          Already have a subscription?{" "}
          <span
            onClick={() => navigateHandler("/login")}
            className="text-[#000000] font-bold cursor-pointer underline text-xl"
          >
            Log in
          </span>
        </div>
        </div>
      </div>
    )}
    {subscribeLoading && <Loader />}
    {loading && <Loader />}
    {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
  </div>

  {/* PC view */}
  {/* PC view */}
<div className="hidden md:flex min-h-screen bg-white">
  {message?.state == true ? (
    <div className="w-full flex items-center justify-center">
      <div className="w-full px-8 py-12 flex flex-col gap-10" style={{ maxWidth: 'clamp(300px, 30vw, 600px)' }}>
        <button onClick={handleReset} className="self-start text-2xl bg-transparent border-none text-black cursor-pointer">&#8617;</button>
        <div className="flex flex-col gap-4 items-center">
          <p style={{ fontSize: 'clamp(13px, 1.2vw, 22px)' }} className="font-semibold text-center text-black">YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}</p>
          <p style={{ fontSize: 'clamp(12px, 1vw, 18px)' }} className="text-center text-gray-300">DO YOU WISH TO:</p>
          <button type="button" disabled={loading} onClick={() => handleChangeCurrency()} style={{ fontSize: 'clamp(12px, 1.1vw, 20px)' }} className="w-full py-[1.5vh] bg-white text-[#1e2738] border-none rounded-xl font-semibold cursor-pointer shadow-md">{`SWITCH TO ${message.switchTo}`}</button>
          <button type="button" disabled={loading} onClick={() => handlewithsame(message.stayWith)} style={{ fontSize: 'clamp(12px, 1.1vw, 20px)' }} className="w-full py-[1.5vh] bg-transparent text-black border border-gray-400 rounded-xl font-semibold cursor-pointer">{`STAY WITH ${message.stayWith}`}</button>
        </div>
      </div>
    </div>
  ) : (
    <div className="w-full flex flex-col py-[4vh]">
      <div className="flex items-center gap-8 mb-[3vh]" style={{ paddingLeft: "25%" }}>
        <img src="/yogamezxr.png" style={{ mixBlendMode: 'multiply' }} className="h-12 md:h-16 w-auto object-contain max-w-[200px]" alt="YoGamesXR Logo" />
        <img src="/assets/images/econet_logo.png" className="h-12 md:h-16 w-auto object-contain max-w-[200px]" alt="Econet Logo" />
      </div>
      <div className="mb-[3vh]" style={{ paddingLeft: '25%' }}>
        <h1 style={{ fontSize: 'clamp(22px, 2.5vw, 48px)' }} className="font-bold text-[#3CB8D4] mb-1">Choose your power!</h1>
        <p style={{ fontSize: 'clamp(14px, 1.3vw, 26px)' }} className="text-black font-bold">Select subscription package.</p>
      </div>

      <div className="flex flex-col items-center w-full">
        <div className="flex flex-col w-full" style={{ gap: 'clamp(10px, 1.5vh, 24px)', width: 'clamp(220px, 20vw, 380px)' }}>

          <div className="flex flex-col gap-1">
            <label style={{ fontSize: 'clamp(12px, 1vw, 18px)' }} className="font-normal text-black">Phone number</label>
            <div className="relative flex items-center">
              <input ref={inputRef} type="tel" placeholder="0778106925" value={msisdn} onChange={(e) => setMsisdn(e.target.value)} style={{ fontSize: 'clamp(12px, 1vw, 18px)', padding: 'clamp(8px, 1.2vh, 16px) clamp(12px, 1vw, 20px)' }} className="w-full bg-[#E8E8E8] text-black placeholder-gray-500 border-none rounded-lg outline-none pr-10" />
              <span className="absolute right-3 bg-black rounded-full w-5 h-5 flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-1">
            <label style={{ fontSize: 'clamp(12px, 1vw, 18px)' }} className="font-normal text-black">Choose Currency</label>
            <div className="flex gap-0 bg-[#E5E5E5] rounded-lg overflow-hidden">
              {currencyOptions.map((currency) => (
                <button key={currency.value} type="button" onClick={() => handleCurrencyChange(currency)} style={{ fontSize: 'clamp(12px, 1vw, 18px)', padding: 'clamp(8px, 1.2vh, 16px)' }} className={`flex-1 font-medium cursor-pointer transition-all ${selectedCurrency?.value === currency.value ? "bg-[#3CB8D4] text-black shadow-sm rounded-lg" : "bg-transparent text-gray-600"}`}>{currency.label}</button>
              ))}
            </div>
          </div>

          {selectedCurrency && (
            <div className="flex flex-col gap-1">
              <label style={{ fontSize: 'clamp(12px, 1vw, 18px)' }} className="font-normal text-black flex justify-between items-center border-b border-gray-300 pb-2">
                <span>Select a package of your choice</span>
                <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>
              </label>
              <div className="flex flex-col items-center gap-0 bg-white w-full">
                {packOptions.map((pack, index) => (
                  <button key={pack.value} type="button" onClick={() => setSelectedPack(pack)} style={{ fontSize: 'clamp(12px, 1vw, 18px)', padding: 'clamp(10px, 1.2vh, 18px) clamp(12px, 1vw, 20px)' }} className={`relative w-full font-normal cursor-pointer flex items-center transition-all border-b border-gray-300 ${selectedPack?.value === pack.value ? "bg-[#E8E8E8] text-black" : "bg-white text-black"} ${index === packOptions.length - 1 ? "border-b-0" : ""}`}>
                    <span className="absolute left-1/2 -translate-x-1/2">{pack.label}</span>
                    {selectedPack?.value === pack.value && (<svg className="absolute right-3 w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>)}
                  </button>
                ))}
              </div>
            </div>
          )}

          {selectedPack && (
            <button type="button" onClick={submitHandler} style={{ fontSize: 'clamp(13px, 1.1vw, 20px)', padding: 'clamp(10px, 1.5vh, 18px)' }} className="w-full bg-[#3CB8D4] text-black border-none rounded-lg font-semibold cursor-pointer mt-2">Subscribe</button>
          )}

          <div style={{ fontSize: 'clamp(12px, 1vw, 16px)' }} className="text-center text-gray-500 pt-2">
            Already have a subscription?{" "}
            <span onClick={() => navigateHandler("/login")} className="text-black font-bold cursor-pointer underline">Log in</span>
          </div>
          
        </div>
        {subscribeLoading && <Loader />}
  {loading && <Loader />}
      </div>
    </div>
  )}

 
  {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
</div>
</div>
  );
};

export default SubscriptionPage;
